import {
  FETCH_BULK_REFILL,
  RESET_BULK_REFILL,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const bulkRefillView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BULK_REFILL:
      return { data: action.payload, others: action.others };
    case RESET_BULK_REFILL:
      return initialState;
    default:
      return state;
  }
};

export default bulkRefillView;
